import React from "react";
import "./index.scss";
interface TitleBarProps {
  title: string;
}

export default function TitleBar(props: TitleBarProps): JSX.Element {
  return <div className="title-bar">{props.title}</div>;
}
